export default __webpack_public_path__ + "static/media/lifesatisfaction3Img4.b1ae93a3.png";